import PropTypes from 'prop-types'
import React, { createContext, useCallback, useContext, useState } from 'react'
import LoadingView from '../../../components/Loading/LoadingView'

export const LoadingContext = createContext({})

export const useLoadingContext = () => {
  const context = useContext(LoadingContext)
  if (context) {
    return context
  }
  return {}
}

export const useLoading = () => {
  const [open, setOpen] = useState()
  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])
  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  return {
    open,
    handleClose,
    handleOpen,
  }
}

export function LoadingProvider({ children }) {
  const hook = useLoading()
  return (
    <LoadingContext.Provider value={hook}>
      <>
        <LoadingView open={hook.open} />
        {children}
      </>
    </LoadingContext.Provider>
  )
}

LoadingProvider.propTypes = {
  children: PropTypes.node,
}
